module.exports = __webpack_public_path__ + "static/media/graffiti_virtual_2.abf3d387.jpg";